<div [style.width.%]="100">
  <h1>選定候補一覧</h1>
  <!-- ヘッダー部分 -->
  <div class="block-column">
    <div>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">注文コード割当</label>
            <div class="list-input-content">
              <app-order-num-quota-code-combo-box [height]="29" id="cmb_OrderNumQuota" #cmb_OrderNumQuota
                [subid]="'cmb_OrderNumQuota'" [(ngModel)]="parentModel.orderNumQuotaCode" [blank]="false"
                [labelField]="'OrderNumQuotaCodeName'" [initAutoLoad]="false" [orderCode]="parentModel.componentOrderCode"
                [mediumType]="parentModel.mediumType" (loadCompleted)="orderNumQuotaLoadCompleted($event)"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-order-num-quota-code-combo-box>
            </div>
            <div class="list-input-content">
              <app-radio-label name="rbtn_selectBundleCatalogRound" label="束ね企画回への選定" [disabled]="!parentModel.enabledBundleCatalogRound"
                id="rbtn_selectBundleCatalogRound" #rbtn_selectBundleCatalogRound [subid]="'rbtn_selectBundleCatalogRound'"
                [checked]="parentModel.radioGroup === '1'" [forcedEnabledMode]="'true'" [tabindex]="0" value="1" [(ngModel)]="parentModel.radioGroup"
                (change)="eventSelectBundleCatalogRoundHandler()"></app-radio-label>
              <app-radio-label name="rbtn_selectSingleBundleCatalogRound" label="単企画回への選定" [disabled]="!parentModel.enabledSingleBundleCatalogRound"
                id="rbtn_selectSingleBundleCatalogRound" #rbtn_selectSingleBundleCatalogRound [subid]="'rbtn_selectSingleBundleCatalogRound'"
                [checked]="parentModel.radioGroup === '2'" [forcedEnabledMode]="'true'" [tabindex]="0" value="2" [(ngModel)]="parentModel.radioGroup"
                (change)="eventSelectBundleCatalogRoundHandler()"></app-radio-label>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">特集コード割当</label>
            <div class="list-input-content" style="height: 29px;">
              <select class="combo-box-normal" forcedEnabledMode="true" [tabindex]="0"
                  [(ngModel)]="parentModel.featureCode" style="width:25rem">
                <option value=""></option>
                <ng-template ngFor let-item [ngForOf]="parentModel.featureCodeList">
                  <option value="{{item.FeatureCode}}">{{item.FeatureCode + ':' + item.FeatureName}}</option>
                </ng-template>
              </select>
              
            </div>
          </div>
          <button class="btn-secondary" id="btn_searchGoods" class="btn-secondary"
            (click)="eventKYMW0300_CLICKHandler()" forcedEnabledMode="true"
            tabindex="0">商品検索</button>
        </div>
        <div class="action-area">
          <div class="guide-label">
            <label class="lbl-outside-handling-period">取扱期間外</label>
            <label class="lbl-temporary-registration">仮登録</label>
            <label class="lbl-own-medium">表示の媒体で選定</label>
            <label class="lbl-same-group">同一グループで選定</label>
            <label class="lbl-other-group">別グループで選定</label>
          </div>
          <div class="column-list">
            <label class="list-input-title">表示項目</label>
            <div class="list-input-content">
              <select class="combo-box-normal" id="cmb_DisplaySet_Standard" [(ngModel)]="parentModel.displayItem"
                forcedEnabledMode="true" [tabindex]="0">
                <ng-template ngFor let-item [ngForOf]="targetSetModel.displayItemSet">
                  <option value="{{item.data}}">{{item.label}}</option>
                </ng-template>
              </select>
            </div>
          </div>
          <app-pager #standardPager
            [prevDisabled]="targetSetModel.totalNum === 0 || targetSetModel.startDispNum <= 100"
            [nextDisabled]="targetSetModel.totalNum === 0 || targetSetModel.endDispNum === targetSetModel.totalNum"
            [totalNum]="targetSetModel.totalNum" [startNum]="targetSetModel.startDispNum"
          
            [endNum]="targetSetModel.endDispNum" (prevHandler)="eventDisplay_CLICKHandler(1)"
            (nextHandler)="eventDisplay_CLICKHandler(2)">
          </app-pager>
        </div>
      </div>
      <!-- 選定候補一覧-->
      <wj-flex-grid class="select-target-list" id="dg_SelectTargetList" #dg_SelectTargetList
        [itemsSource]="targetSetModel.selectTargetList" [isReadOnly]="true" [allowSorting]="false"
        [allowDragging]="'None'" [headersVisibility]="'Column'" [selectionMode]="'ListBox'" [frozenColumns]="6"
        (click)="eventSelectTargetList_HEADERRELEASEHandler($event, dg_SelectTargetList)"
        (selectionChanged)="this.eventSelectTarget_ITEMCLICKHandler()"
        (scrollPositionChanged)="setColorPattern(dg_SelectTargetList)" forcedEnabledMode="true" [tabindex]="0">
        <wj-flex-grid-column [minWidth]="5" [header]="' '" [allowResizing]="true" [visible]="true"
          [binding]="'DispStatus'" [width]="30">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DispStatus}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [allowResizing]="true" [visible]="true"
          [binding]="'ClassCode'" [width]="60"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'中分類'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'MiddleClassCode'" [width]="55"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'小分類'" [allowResizing]="true" [visible]="true"
          [binding]="'SmallClassCode'" [width]="70"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品案内用商品名'" [allowResizing]="true" [visible]="true"
          [binding]="'GuideGoodsName'" [width]="205"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品案内用規格名'" [allowResizing]="true" [visible]="true"
          [binding]="'GuideStandardName'" [width]="205"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [allowResizing]="true" [visible]="true"
          [binding]="'PCode'" [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeIB'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeTO'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeGU'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeTI'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeSA'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeTK'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeNA'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＪＡＮ（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JanCodeNI'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前企画回'" [allowResizing]="true" [visible]="true"
          [binding]="'JustBeforeCatalogId'" [width]="83"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceIB'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceTO'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceGU'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceTI'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceSA'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceTK'" [width]="132"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceNA'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前供給価（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforeSupplyPriceNI'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeSupplyPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceIB'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceTO'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceGU'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceTI'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceSA'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceTK'" [width]="133"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceNA'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直前仕入価（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeCostPriceNI'" [width]="125"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeCostPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（合計）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprALL | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（い）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprIB'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprIB | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（と）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprTO'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprTO | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（ぐ）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprGU'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprGU | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（ち）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprTI'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprTI | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（さ）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprSA'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprSA | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（とう）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprTK'" [width]="131" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprTK | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（な）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprNA'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprNA | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近ＧＰＲ（に）'" [allowResizing]="true" [visible]="true"
          [visible]="parentModel.displayItem !== '2'" [binding]="'JustBeforeGprNI'" [width]="124" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeGprNI | number:'1.1-1' | comma | suffix:'%'}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（合計）'" [allowResizing]="true" [visible]="true"
          [binding]="'JustBeforeResultsNumALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumIB'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumTO'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumGU'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumTI'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumSA'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumTK'" [width]="132"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumNA'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績数（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsNumNI'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsNumNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（合計）'" [allowResizing]="true" [visible]="true"
          [binding]="'JustBeforeResultsPriceALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceIB'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceTO'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceGU'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceTI'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceSA'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceTK'" [width]="131"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceNA'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'直近実績額（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'JustBeforeResultsPriceNI'" [width]="124"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforeResultsPriceNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'平均実績額（全体）'" [allowResizing]="true" [visible]="true"
          [binding]="'AvgResultPriceALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.AvgResultPriceALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardIB'" [width]="110"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardTO'" [width]="109"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardGU'" [width]="109"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardTI'" [width]="109"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardSA'" [width]="109"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardTK'" [width]="117"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardNA'" [width]="110"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'供給通常（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'SupplyPriceStandardNI'" [width]="109"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.SupplyPriceStandardNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameIB'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameTO'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameGU'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameTI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameSA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameTK'"
          [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameNA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'PayeeClientNameNI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameIB'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameTO'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameGU'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameTI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameSA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameTK'"
          [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameNA'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'発注先取引先（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OrderClientNameNI'"
          [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'最大実績数（全体）'" [allowResizing]="true" [visible]="true"
          [binding]="'MaxResultNumALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.MaxResultNumALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'平均実績数（全体）'" [allowResizing]="true" [visible]="true"
          [binding]="'AvgResultNumALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.AvgResultNumALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'最小実績数（全体）'" [allowResizing]="true" [visible]="true"
          [binding]="'MinResultNumALL'" [width]="139" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.MinResultNumALL | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'仕分温度帯'" [allowResizing]="true" [visible]="true"
          [binding]="'AssortTempName'" [width]="83"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'紐付（親Ｐコード）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'RelateMasterCode'"
          [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiIB'" [width]="96"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiTO'" [width]="95"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiGU'" [width]="95"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiTI'" [width]="95"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiSA'" [width]="95"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiTK'" [width]="103"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiNA'" [width]="96"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ＰＩ値（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '1' ? false : true" [binding]="'JustBeforePiNI'" [width]="95"
          [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.JustBeforePiNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceIB'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceTO'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceGU'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceTI'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceSA'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceTK'" [width]="145"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceNA'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'原産国加工地（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'OriginPlaceNI'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（い）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameIB'" [width]="130"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（と）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameTO'" [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（ぐ）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameGU'" [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（ち）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameTI'" [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（さ）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameSA'" [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（とう）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameTK'" [width]="138"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（な）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameNA'" [width]="130"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名称（に）'" [allowResizing]="true" [visible]="true"
          [binding]="'MakerNameNI'" [width]="128"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameIB'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameTO'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameGU'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameTI'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameSA'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameTK'" [width]="135"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameNA'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ブランド区分（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BrandNameNI'" [width]="127"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'次回企画回'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '2' ? false : true" [binding]="'NextCatalog'"
          [width]="90"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeIB'" [width]="177"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeTO'" [width]="176"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeGU'" [width]="176"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeTI'" [width]="176"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeSA'" [width]="176"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeTK'" [width]="185"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeNA'" [width]="177"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'eBASE仕様書コード（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'EbaseSpecCodeNI'" [width]="176"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardIB'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardTO'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardGU'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardTI'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardSA'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardTK'" [width]="145" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardNA'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'単品仕入通常（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'CostPriceStandardNI'" [width]="138" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.CostPriceStandardNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumIB'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumTO'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumGU'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumTI'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumSA'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumTK'" [width]="118" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumNA'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'確定入数（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FixContainNumNI'" [width]="111" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FixContainNumNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'バイヤーコード'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'BuyerCode'" [width]="110"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'い'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopIB'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopIB}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'と'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopTO'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopTO}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ぐ'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopGU'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopGU}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ち'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopTI'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopTI}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'さ'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopSA'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopSA}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'とう'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopTK'" [width]="35" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopTK}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'な'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopNA'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopNA}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'に'" [allowResizing]="true" [visible]="true"
          [binding]="'DealEnableCoopNI'" [width]="30" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'center'">{{cell.item.DealEnableCoopNI}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（い）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeIB'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeIB | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（と）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeTO'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeTO | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（ぐ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeGU'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeGU | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（ち）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeTI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeTI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（さ）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeSA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeSA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（とう）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeTK'" [width]="103" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeTK | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（な）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeNA'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeNA | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'加工賃（に）'" [allowResizing]="true"
          [visible]="parentModel.displayItem === '3'" [binding]="'FcmcFeeNI'" [width]="96" [align]="'right'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'right'">{{cell.item.FcmcFeeNI | comma}}</div>
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>